var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.25h-3a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75Zm-.75 6h-1.5v-4.5h1.5v4.5Zm12.75-9h-3a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75Zm-.75 9h-1.5v-7.5h1.5v7.5ZM10.5.25h-3a.75.75 0 0 0-.75.75v15a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75V1a.75.75 0 0 0-.75-.75Zm-.75 15h-1.5V1.75h1.5v13.5Z"
  })));
};
export default SvgDashboard;